import { AgentRun } from '@lucidtech/las-sdk-browser';
import { useCallback, useMemo } from 'react';

import { useFilteredAgentRunsQuery } from './api';

const findNextRun = async (runs: AgentRun[], currentIndex: number) => {
  if (runs?.length === 0) return;

  for (const candidate of runs.slice(currentIndex + 1)) {
    if (candidate.status === 'ready-for-review') {
      return candidate;
    }
  }
};

export const useNextRunId = (agentId: string, runId: string) => {
  const { data } = useFilteredAgentRunsQuery({ agentId });

  const runs = useMemo(() => data?.pages?.flatMap((page) => page.data) ?? [], [data]);
  const currentIndex = useMemo(() => runs.findIndex((run) => run?.runId === runId), [runId, runs]);

  const next = useMemo(() => {
    return runs[currentIndex + 1];
  }, [currentIndex, runs]);

  const previous = useMemo(() => {
    return runs[currentIndex - 1];
  }, [currentIndex, runs]);

  const nextToReview = useCallback(async () => {
    return await findNextRun(runs, currentIndex);
  }, [currentIndex, runs]);

  return {
    currentRunIndex: currentIndex,
    currentRun: runs[currentIndex],
    previousRun: previous,
    nextRun: next,
    nextRunToReview: nextToReview,
    totalRuns: runs.length,
  };
};
